module.exports = require("http");


//////////////////
// WEBPACK FOOTER
// external "http"
// module id = 230
// module chunks = 0